import { useRouteMatch } from 'react-router-dom';

const paths = ['/diagnose', '/lab', '/explore'];

export const useMobileSecondaryNavbarStatus = (): boolean => {
  const match = useRouteMatch(paths);

  return match ? match.isExact : false;
};
